import { combineReducers } from 'redux';
import { connectRouter } from 'connected-react-router'

import userReducer from './user/user.reducer';
import roomReducer from './room/room.reducer';
import clientReducer from './client/client.reducer';
import serviceGroupReducer from './serviceGroup/serviceGroup.reducer';
import notificationReducer from './notification/notification.reducer';
import profileReducer from './profile/profile.reducer';
import companyReducer from './company/company.reducer';
import loadingReducer from './loading/loading.reducer';
import ticketReducer from './ticket/ticket.reducer';
import fieldReducer from './field/field.reducer';
import filterReducer from './filter/filter.reducer';
import indicatorReducer from './indicator/indicator.reducer';
import whatsappReducer from './whatsapp/whatsapp.reducer';
import userActivityLogReducer from './userActivityLog/userActivityLog.reducer';

const createRootReducer = (history) => combineReducers({
    router: connectRouter(history),
    user: userReducer,
    rooms: roomReducer,
    clients: clientReducer,
    serviceGroups: serviceGroupReducer,
    notification: notificationReducer,
    profiles: profileReducer,
    companies: companyReducer,
    loads: loadingReducer,
    tickets: ticketReducer,
    field: fieldReducer,
    filter: filterReducer,
    indicators: indicatorReducer,
    whatsapp: whatsappReducer,
    userActivityLogs: userActivityLogReducer
});

export default createRootReducer;